import { Link } from 'react-router-dom';
import AppRoute from "../../utils/AppRoute";

const Error = () => {
  return (
    <section className='section'>
      <h2>404</h2>
      <p>Pagina non trovata</p>
      <Link to={AppRoute.BASE}>Torna alla homepage</Link>
    </section>
  );
};
export default Error;
